export default __webpack_public_path__ + "static/media/office-building.ac9f6642.jpeg";